namespace SorAraBul.PropertyManagement {
    export interface TenantPetsRow {
        Id?: number;
        TenantDetailId?: string;
        PetId?: number;
    }

    export namespace TenantPetsRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'PropertyManagement.TenantPets';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            TenantDetailId = "TenantDetailId",
            PetId = "PetId"
        }
    }
}
